module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/258-mongolia-5296f2014f84ebc6c4d93f2ab01c119b.svg";